import { useEffect, useState } from "react";
import {
  buildTimeDropdownOptions,
  convertToMinutes,
  formatDateForBackend,
} from "../utils";

const getOptionAbsoluteMinutes = (option) => {
  const baseMinutes = convertToMinutes(option?.timeValue || option?.value || "");
  return baseMinutes + (option?.isNextDay ? 1440 : 0);
};

export const UseTimeOptions = (
  selectedOutletTiming,
  selectedDate,
  isOutletExtended = false
) => {
  const [timeOptions, setTimeOptions] = useState([]);

  useEffect(() => {
    if (
      selectedOutletTiming &&
      Object.keys(selectedOutletTiming).length > 0 &&
      selectedDate
    ) {
      const dateKey = formatDateForBackend(selectedDate);
      const timingArray = selectedOutletTiming[dateKey] || [];

      const activeTiming = timingArray.find(
        (timing) => timing?.off === 0 && timing?.open && timing?.close
      );

      let crossesMidnight = false;
      let absoluteEndMinutes = 24 * 60; // exclusive upper bound -> shows through 11:55 PM

      if (activeTiming) {
        const openingMinutes = convertToMinutes(activeTiming.open);
        const endMinutes = convertToMinutes(activeTiming.close);
        crossesMidnight = endMinutes <= openingMinutes;
        const timingAbsoluteEndMinutes = crossesMidnight
          ? endMinutes + 1440
          : endMinutes;
        const extendedAbsoluteEndMinutes = 24 * 60 + 6 * 60; // exclusive upper bound -> shows through 5:55 AM (+1)
        absoluteEndMinutes = isOutletExtended
          ? Math.max(timingAbsoluteEndMinutes, extendedAbsoluteEndMinutes)
          : absoluteEndMinutes;
      } else if (isOutletExtended) {
        absoluteEndMinutes = 24 * 60 + 6 * 60;
      }

      const dropdownSlots = buildTimeDropdownOptions({
        isOutletExtended: isOutletExtended || crossesMidnight,
        includeNextDay: isOutletExtended || crossesMidnight,
      }).filter((option) => {
        const optionAbsoluteMinutes = getOptionAbsoluteMinutes(option);
        return (
          optionAbsoluteMinutes >= 0 &&
          optionAbsoluteMinutes < absoluteEndMinutes
        );
      });

      setTimeOptions(dropdownSlots);
    }
  }, [selectedOutletTiming, selectedDate, isOutletExtended]);

  return timeOptions;
};
